import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Card, Tooltip, Spin, Table, Tag } from "antd";
import Avatar from "../avatar";
import svg from "../../utils/images/zobu.svg";
import logo from "../../utils/images/zostelLogo.svg";
import moment from "moment";
import Profile from "../../components/profile";
import "./styles.css";
import LeadContext from "../../contexts/leads";

function Leads({ id, props }) {
  const [leads, setLeads] = useState({ leads: [] });
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [lead, setLead] = useState({});
  const [error, setError] = useState(false);
  const [questions, setQuestions] = useState({ question: [] });
  const { supplyApi } = useContext(LeadContext);

  const card_head = {
    textAlign: "center",
    fontSize: 25,
    color: "#2e2e2e"
  };

  useEffect(() => {
    loadLeads();
    loadQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadQuestions = () => {
    setLoading(true);
    supplyApi
      .get("seed/")
      .then(response => {
        setQuestions({ question: response.data.questions });
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        console.log(error, err);
      });
  };

  const loadLeads = () => {
    setLoading(true);
    var url = id
      ? window.location.pathname === `/${props}`
        ? `leads/?page=1&per_page=5&state_id=${id}`
        : `leads/?page=1&per_page=5&district_id=${id}`
      : `leads/?page=1&per_page=5`;
    supplyApi
      .get(url)
      .then(response => {
        setLeads({ leads: response.data.leads });
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        console.log(error, err);
      });
  };

  const showDrawer = e => {
    setLead(
      leads.leads.find(lead =>
        lead.answers.find(x => x.question === 10)
          ? lead.answers.find(x => x.question === 10).content === e.name
          : null
      )
    );
    setVisible(() => true);
  };

  if (loading !== false) {
    return (
      <Row>
        <Col xs={24} sm={24} md={16} lg={16} xl={16} className="lead_card">
          <Card title="Latest Leads" headStyle={card_head} className="board">
            <div style={{ textAlign: "center" }}>
              <Spin style={{ textAlign: "center", marginTop: "20vh" }} />
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} className="lead_card">
          <Card title="Recent Activity" headStyle={card_head} className="board">
            <div style={{ textAlign: "center" }}>
              <Spin style={{ textAlign: "center", marginTop: "20vh" }} />
            </div>
          </Card>
        </Col>
      </Row>
    );
  }

  if (leads.leads.length > 0) {
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 150,
        ellipsis: true,
        fixed: "left",
        render: text => {
          return (
            <p className="lead">
              <Avatar svg={svg} className="lead_avatar" />
              <span className="lead_name">{text}</span>
            </p>
          );
        }
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
        width: 150,
        ellipsis: true
      },
      {
        title: "Assets",
        key: "tags",
        dataIndex: "tags",
        width: 80,
        render: tags => (
          <span>
            {" "}
            {tags &&
              tags.map((tag, id) => {
                if (tag === "Owns Property") {
                  return (
                    <Tooltip title="Owns Property" key={id}>
                      <img
                        src={logo}
                        alt="property"
                        style={{ height: 20, width: 20, marginRight: 7 }}
                      />
                    </Tooltip>
                  );
                }
                if (tag === "NA") {
                  return (
                    <Tooltip title="Not Available" key={id}>
                      <Tag color={"red"} key={tag}>
                        {tag}
                      </Tag>
                    </Tooltip>
                  );
                }
                return (
                  tag && (
                    <Tooltip title="Money(in lakhs)" key={id}>
                      <Tag color={"green"} key={tag}>
                        {tag}
                      </Tag>
                    </Tooltip>
                  )
                );
              })}
          </span>
        )
      },
      {
        title: "Submitted",
        dataIndex: "submitted",
        key: "submitted",
        width: 80,
        ellipsis: true
      },
      {
        title: "Assigned To",
        key: "assigned",
        width: 80,
        dataIndex: "assigned",
        render: assigned => (
          <span>
            <a href="# " style={{ color: "#f05622" }}>
              {assigned ? assigned : "Unassigned"}
            </a>
          </span>
        )
      }
    ];

    const data = leads.leads.map(lead => {
      return {
        key: lead.answers.find(x => x.question === 10)
          ? lead.answers.find(x => x.question === 10).content
          : "NA",
        name: lead.answers.find(x => x.question === 10)
          ? lead.answers.find(x => x.question === 10).content
          : "NA",
        location: lead.answers.find(x => x.question === 3)
          ? lead.answers.find(x => x.question === 3).content
          : "NA",
        tags: [
          lead.answers.find(x => x.question === 20) ? "Owns Property" : "NA",
          lead.answers.find(x => x.question === 18)
            ? lead.answers.find(x => x.question === 18).content
            : "NA"
        ],
        submitted: moment
          .utc(lead.time_create)
          .local()
          .fromNow(),
        assinged: lead.assinged
      };
    });

    return (
      <Row>
        <Col xs={24} sm={24} md={16} lg={16} xl={16} className="lead_card">
          <Card
            className="board"
            title="Latest Leads"
            headStyle={card_head}
            extra={
              <a href="/leads" style={{ cursor: "pointer", color: "#f05622" }}>
                See All
              </a>
            }
          >
            <Table
              columns={columns}
              dataSource={data}
              pagination={false}
              style={{ marginTop: 10 }}
              scroll={{ x: 0, y: 300 }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: event => {
                    showDrawer(record);
                  }
                };
              }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={24} md={8} lg={8} xl={8} className="lead_card">
          <Card title="Recent Activity" headStyle={card_head} className="board">
            <p style={{ textAlign: "center", marginTop: "20vh" }}>
              No Activities
            </p>
          </Card>
        </Col>
        <Profile
          visible={visible}
          setVisible={setVisible}
          question={questions.question}
          lead={lead}
        />
      </Row>
    );
  }
  return (
    <Row>
      <Col xs={24} sm={24} md={16} lg={16} xl={16} className="lead_card">
        <Card title="Latest Leads" headStyle={card_head} className="board">
          <p style={{ textAlign: "center", marginTop: "20vh" }}>No Leads</p>
        </Card>
      </Col>
      <Col xs={24} sm={24} md={16} lg={8} xl={8} className="lead_card">
        <Card title="Recent Activity" headStyle={card_head} className="board">
          <p style={{ textAlign: "center", marginTop: "20vh" }}>
            No Activities
          </p>
        </Card>
      </Col>
    </Row>
  );
}

export default Leads;
